/**
 * Testimonials Carousel - Splide slider initialization
 */
(function ($) {
    function init() {
        $('.splide_testimonials').each(function (i, e) {
            // Skip if already initialized
            if ($(e).hasClass('is-initialized')) return;

            let splide = new Splide(e, {
                perPage: 3,
                rewind: true,
                gap: 20,
                arrows: true,
                pagination: true,
                breakpoints: {
                    1200: {
                        perPage: 2
                    },
                    768: {
                        perPage: 1,
                        arrows: false,
                    },
                }
            });

            splide.mount();
        });
    }

    // Initialize on DOM ready
    $(document).ready(init);

    // Re-initialize on AJAX content load (for dynamic content)
    $(document).on('ajaxComplete', init);

})(jQuery);
